import React from "react";
import { Box, Card, CardContent, Grid, Divider } from "@mui/material";
import { Link } from "react-router-dom";
import TAGlogo from "assets/images/TAGlogo.svg";
import accountCreatedIcon from "assets/images/accountCreatedIcon.svg";

function AccountCreated() {
  return (
    <div className="b-login-container">
      <Box className="b-login-container__box">
        <Grid container spacing={2}>
          <Grid item xs={8}>
            <img
              className="b-authorized-container__logo"
              src={TAGlogo}
              alt="Error in loading"
            />
          </Grid>
        </Grid>
      </Box>
      <Divider />
      <div className="b-login-container__body">
        <Grid
          container
          spacing={2}
          direction="column"
          alignItems="center"
          justify="center"
          className="b-login-container__alignment"
        >
          <Grid item xs={12} className="b-login-container__card">
            <Card className="b-login-container__cardHead">
              {/* <CardContent className="b-login-container__content">
                <Typography class="login-card-header">
                  <div>
                    <span className="default-card-header-padding">
                      Your account has been created!
                    </span>
                  </div>
                </Typography>
              </CardContent> */}
              <CardContent className="b-login-container__content">
                <div className="default-card-header-padding">
                  <h2 className="b-login-container__content-text">
                    Your account has been created!
                  </h2>
                </div>
              </CardContent>

              <CardContent className="b-login-container__cardContent">
                <div>
                  <img
                    className="b-authorized-container__image"
                    alt=""
                    src={accountCreatedIcon}
                  />
                </div>
                <div className="b-authorized-container__div-text">
                  <span className="b-authorized-container__span-text">
                    Your account has been successfully created.
                    <br /> Click below to log in.
                  </span>
                </div>
                <div className="b-authorized-container__log-btn">
                  <Link className="b-authorized-container__btn-text" to="/">
                    Go to Log In
                  </Link>
                </div>
                {/* </div> */}
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </div>
    </div>
  );
}

export default AccountCreated;
